<template>
  <m-base
    :showTopBorder="pattern.showTopBorder"
    :showRightBorder="pattern.showRightBorder"
    :showBottomBorder="pattern.showBottomBorder"
    :showLeftBorder="pattern.showLeftBorder"
    :showHeader="false"
    :showBorderRadius="pattern.showBorderRadius"
    :boxType="pattern.boxType"
  >
    <div slot="content" class="d-flex flex-column van-row--align-center">
      <div class="w-100 d-flex flex-row van-row--justify-space-between van-row--align-center">
        <van-image lazy-load width="80" height="80" round :src="params.icon" />
        <div class="ml-2 flex-1">
          <div>{{params.title}}</div>
          <span class="text-secondary fs-14">{{params.subTitle}}</span>
        </div>
      </div>
      <div
        class="mt-3 fs-14 themeBGColor pt-2 pb-2 text-white w-75 flex-center"
        @click="showimage"
      >关注公众号</div>
      <van-dialog v-model="imgDialog.show" :title="imgDialog.title">
        <van-image lazy-load class="image w-100" :src="imgDialog.src" />
        <div class="text-center m-2 w-100 pl-3 pr-3 btnView">{{imgDialog.desc}}</div>
      </van-dialog>
    </div>
  </m-base>
</template>

<script>
import {
  mapState,
  mapMutations
} from 'vuex';
export default {
  props: {
    params: {
      type: Object,
      default: () => {
        return {
          title: '公众号名称',
          subTitle: '文字简介',
          icon: 'https://res.zhifu88.cn/alachuang/854020200508211355/hot.png'
        }
      }
    },
    pattern: {
      type: Object,
      default: () => {
        return {
          showTopBorder: false,
          showRightBorder: false,
          showBottomBorder: true,
          showLeftBorder: false,
          showBorderRadius: false,
          boxType: 'block',
          circle: true
        }
      }
    },
  },
  data () {
    return {
      myData: this.data,
      imgDialog: {
        show: false,
        title: '长按识别二维码',
        src: ''
      }
    };
  },
  computed: {
    ...mapState(['orgInfo'])
  },
  mounted () {
  },
  created () {

  },
  methods: {
    showimage () {
      let { imgDialog } = this
      imgDialog.show = true;
      imgDialog.src = this.orgInfo.weChatWebQR
      console.log(imgDialog.src)
    },
  },
  watch: {
    data: {
      deep: true,
      handler: function (newVal) {
        this.myData = newVal
      }
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
